export var ArcGisPOIColumn;
(function (ArcGisPOIColumn) {
    ArcGisPOIColumn["Id"] = "OBJECTID";
    ArcGisPOIColumn["Name"] = "Name";
    ArcGisPOIColumn["AlternativeName"] = "AlternativeName";
    ArcGisPOIColumn["Type"] = "Type";
    ArcGisPOIColumn["Address"] = "Address";
    ArcGisPOIColumn["Ward"] = "Ward";
})(ArcGisPOIColumn || (ArcGisPOIColumn = {}));
